export const SHOW_SUGGESTIONS_AFTER = 2;
export const SUGGESTIONS_LIMIT = 10;
export const DEFAULT_EXECUTION_DELAY = 500;
